import { PoisonedShotEffect } from 'game/extended/heros/ranger/poisoned_shot/poisoned_shot_effect'

export default {
    events: {},
    effects: {
        PoisonedShotEffect
    },
    requirements: {}
}